const SEARCH_FORM_TABS_SLOT_CLASS_NAMES = {
    iconClass: '',
    indicatorClass: '',
    listClass: 'justify-start gap-0 @sm:justify-center @sm:gap-1 @sm:overflow-x-visible @3xl:justify-start @3xl:gap-4 @max-3xl:rounded-sm',
    panelClass: 'w-full max-w-7xl mt-4 bg-primary-1 overflow-hidden @min-3xl:rounded-xl @min-3xl:shadow-lg',
    rootClass: 'overflow-visible',
    tabClass: '',
    tabLabelContentClass: ''
};
export { SEARCH_FORM_TABS_SLOT_CLASS_NAMES };
